import { Card, CardContent } from "@ncoder/ui";

interface StatCardProps {
  icon: React.ElementType;
  iconColor: string;
  label: string;
  value: string | number;
  valueColor?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  icon: Icon,
  iconColor,
  label,
  value,
  valueColor,
}) => (
  <Card>
    <CardContent className="pt-6">
      <div className="flex items-center gap-2">
        <div
          className={`w-8 h-8 ${iconColor} rounded-lg flex items-center justify-center`}
        >
          <Icon className="h-4 w-4" />
        </div>
        <div>
          <div className={`text-2xl font-bold ${valueColor || ""}`}>
            {value}
          </div>
          <div className="text-sm text-muted-foreground">{label}</div>
        </div>
      </div>
    </CardContent>
  </Card>
);
